export default __webpack_public_path__ + "static/media/9.6e3b5123.jpg";